import api from "./client";

// Crew Pass membership applications. These are NOT enquiries: they are
// membership purchases that link to enquiries only once a placement exists.
export const getCrewPassConfig = () => api.get("/crew-pass/config");
export const getCrewPassApplications = (params) => api.get("/crew-pass/applications", { params });
export const getCrewPassApplication = (id) => api.get(`/crew-pass/applications/${id}`);
export const createCrewPassApplication = (data) => api.post("/crew-pass/applications", data);
export const updateCrewPassApplication = (id, data) => api.patch(`/crew-pass/applications/${id}`, data);
export const setCrewPassStage = (id, data) => api.patch(`/crew-pass/applications/${id}/stage`, data);
export const linkCrewPassEnquiry = (id, enquiryId) =>
  api.post(`/crew-pass/applications/${id}/link-enquiry`, null, { params: { enquiry_id: enquiryId } });
export const getCrewPassPipeline = () => api.get("/crew-pass/pipeline");
export const getCrewPassAnalytics = (params) => api.get("/crew-pass/analytics", { params });
export const getCrewPassRemindersDue = () => api.get("/crew-pass/reminders/due");
export const sendCrewPassPaymentLink = (id, currency) =>
  api.post(`/crew-pass/applications/${id}/send-payment-link`, null, { params: { currency } });
